import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import Sidebar from './Sidebar'
import BuySellChart from './BuySellChart'
import { connect } from 'react-redux'
import { fetchStock, fetchValuation } from '../reducers/stock'
import { addSymbolToWatchlist, removeSymbolFromWatchlist, fetchWatchlist } from '../reducers/watchlist'
import { Helmet } from "react-helmet";
import { PriceCard, NumberCard } from './InfoCard'
import { InvestmentReturnGraph, SalesGrowthGraph } from './Graph'
import CompanyInfo from './CompanyInfo'
import Spinner from './Spinner'
import Footer from './Footer'
import zipObject from 'lodash.zipobject';
import rowboat from '../images/rowboat.png'

class Ticker extends Component {

  componentWillMount = () => {
    const { symbol } = this.props
    // If symbol is passed as a prop
    if (symbol) {
      // this.props.fetchStock(symbol);
    } else {
      // if symbol is passed as a url param
      const symbolFromParam = (this.props.match.params.ticker).toUpperCase()
      this.props.fetchStock(symbolFromParam);
    }

    this.props.fetchWatchlist()
  }

  addToWatchlist = () => {
    const { currentSymbol, stockData, valuation } = this.props
    const { fmpData } = stockData

    const entry = {
      symbol: currentSymbol,
      lowBuyRange: valuation.lowBuyRange,
      highBuyRange: valuation.highBuyRange,
      frozenPrice: fmpData.price,
      practicalValuation: valuation.practicalValuation,
      theoreticalValuation: valuation.roundedValuation,
      practicalReturn: valuation.irPractical * 100,
      theoreticalReturn: valuation.irPotential * 100,
      //date: iexData.quote.latestUpdate,
      marketGrowth: valuation.currentSalesGrowth,
      theoreticalGrowth: valuation.theoreticalGDefault,
      userGrowth: valuation.theoreticalGrowthFactor,
      opsType: stockData.reutersData.DynamicOps,
      futurePM: valuation.futurePMFactor,
      futurePE: valuation.futurePEFactor,
      //futurePM: stockData.reutersData.FuturePM,
      //futurePE: stockData.reutersData.FuturePE,
      shrTrend: stockData.reutersData.ShrTrend,
      profitMargin: stockData.reutersData.NormalizedCurrentPM,
      dividend: stockData.reutersData.divYield,
      costofEquity: stockData.reutersData.RA1Round,
      sales: stockData.reutersData.sales_y1,
      shares: stockData.reutersData.shr_ay1,
      PE: stockData.reutersData.PEAvgCompany,
      pmGrowth: valuation.pmGrowth,
      earningsGrowth: valuation.earningsGrowth,
      analystsGrowth: valuation.analystsGrowth,
      futureR: valuation.futureR,
      futureCoE: valuation.futureCoE,
      futureEarningsGrowth: valuation.futureEarningsGrowth,
      futureRf: stockData.reutersData.Rf2
    }

    this.props.addSymbolToWatchlist(entry)
  }

  removeFromWatchlist = () => {
    if (this.inWatchlist()) {
      this.props.removeSymbolFromWatchlist(this.inWatchlist(), this.props.currentSymbol)
    } else {
      console.log('not in investment plans');
    }
  }

  inWatchlist = () => {
    const list = this.props.watchlist.list
    const symbol = this.props.currentSymbol
    if (list) {
      // Get all keys in firebase watchlist from redux
      const keys = Object.keys(list)

      // Get all values in firebase watchlist from redux
      let values = []
      for(let key in list) {
        let value = list[key];
        values.push(value.symbol)
      }

      // Merge key and values arrays together
      // This makes finding the key/value pair easier
      const formattedObj = zipObject(keys, values)

      // Get key for current symbol
      const key = Object.keys(formattedObj).find(key => formattedObj[key] === symbol);

      // return key if exists
      // If key/value does not exist in watchlist return null
      return key;
    }
  }

  updateValuation = (growth, PM, PE) => {
    this.props.fetchValuation(growth, PM, PE)
  }

  render = () => {
    const { currentSymbol, stockData, valuation } = this.props
    const { fmpData, reutersData } = stockData
    const { buySell } = valuation

    if (this.props.isLoading) {
      return (
        <div className="w-100 h-100 pa3 tc pv6">
          <Spinner />
        </div>
      )
    }

    if (this.props.reutersError) {
      return (
        <div className="pa3 mw9 center">
          <div className="br2 shadow-custom bg-white">
            <div className="tc pv6 pv6-ns ph4">
              <img src={rowboat} alt="Rowboat" className=" " style={{width: '250px', height: 'auto'}} />
              <h3 className="f3 fw4 mt4">No valuation for {currentSymbol}</h3>
              <p>Polaris has certain minimum requirements for stocks including market capitalization ($50M), price ($5), trading volume (50K) and sufficient historical data.The company must also be listed on the NASDAQ or New York Stock Exchanges. The company does not meet one or more of these minimum requirements.</p>
            </div>
          </div>
        </div>
      )
    }

    return (
     <div className="">
        <Helmet>
          <title>{currentSymbol || "Polaris"}</title>
        </Helmet>

        <div className="cf">
          {/* Header */}
          <div className="bg-blue white cf pv4">
            <div className="mw9 center cf">
              <div className={`fl w-90 w-60-m w-70-l pa3`}>
              <h1 className="ma0 f2-ns f3 fw4"> <a className="link green" href={`https://finance.yahoo.com/quote/${currentSymbol}`} target="_blank">{currentSymbol} </a></h1>
                <p className="f5 white-50 ma0">
                {this.props.stockData.fmpData.name}
                </p>
              </div>


              <div className={`fl w-10 w-40-m w-30-l pa3 cf`}>
                {!this.inWatchlist() ? (
                  <button className="ba bw1 b--white dib br2 pointer bg-transparent white pa2 fr" onClick={this.addToWatchlist}>
                    <i className="material-icons white v-mid f4 fw6" >add</i>
                    <span className="dn dib-ns v-mid fw6 mr1">Add to Plans</span>
                  </button>
                ) : (
                  <button className="ba bw1 b--white dib br2 pointer bg-transparent white pa2 fr" onClick={this.removeFromWatchlist}>
                    <i className="material-icons white v-mid f4 fw6">remove_circle_outline</i>
                    <span className="dn dib-ns v-mid fw6 mr1 ml1">Remove from Plans</span>
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Left Column */}
          <div className="mw9 center">
            <div className="fl w-100 w-two-thirds-ns pa3 relative top--2">
              <PriceCard
                currentPrice={fmpData.price}
                marketChange={fmpData.change}
                marketChangePercent={fmpData.changesPercentage}
                priceMomentum={valuation.priceMomentum}
                symbol={currentSymbol}
                opsType={reutersData.DynamicOps}
                numAnalysts={reutersData.epsn_eg5}
                />

              <NumberCard
                title="Investment Return"
                description="Projected average annual investment return over the next 5 years (assumes dividends are reinvested)"
                numberType="%"
                current={valuation.currentInvestmentReturn * 100}
                practical={valuation.irPractical * 100}
                theoretical={valuation.irPotential * 100} />

              <NumberCard
                title="Valuation"
                description="The present value of the company's risk adjusted, projected cash flows"
                numberType="$"
                current={fmpData.price}
                practical={valuation.practicalValuation}
                theoretical={valuation.roundedValuation} />

              <NumberCard
                title="Sales Growth"
                description="Projected average annual sales growth over the next 5 years"
                numberType="%"
                current={valuation.currentSalesGrowth * 100}
                practical={valuation.practicalGrowthFactor * 100}
                theoretical={valuation.theoreticalGrowthFactor * 100} />

              <BuySellChart buySell={buySell} symbol={currentSymbol} currentPrice={fmpData.price} />


              <InvestmentReturnGraph symbol={currentSymbol} valuation={valuation}/>
              <SalesGrowthGraph symbol={currentSymbol} valuation={valuation}/>
              <CompanyInfo reutersData={reutersData} fmpData={fmpData} symbol={currentSymbol} />
            
            </div>
            <Sidebar
              updateValuation={this.updateValuation}
              currentSymbol={currentSymbol}
              valuation={valuation}
              industryRisk={reutersData.ibeta}
              sp500Risk={1} />
          </div>
        </div>
      <Footer />
    </div>
    )
  }
}

export default connect(
  (state) => ({
    currentSymbol: state.stock.currentSymbol,
    stockData: state.stock.stockData,
    valuation: state.stock.valuation,
    isLoading: state.stock.isLoading,
    reutersError: state.stock.reutersError,
    currentUser: state.user.currentUser,
    watchlist: state.watchlist
  }),
  {
    fetchStock,
    fetchValuation,
    addSymbolToWatchlist,
    removeSymbolFromWatchlist,
    fetchWatchlist
  }
)(withRouter(Ticker))



// WEBPACK FOOTER //
// ./src/components/Ticker.js